<template>
  <button
    class="next-button"
    :class="{'next-button__disable': disabled}"
    @click="clickHandler"
    :disabled="disabled"
  >{{ label }}</button>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    label: VueTypes.string.isRequired,
    disabled: VueTypes.bool.isRequired
  },
  methods: {
      clickHandler(e) {
          if (this.disabled) {
              return
          }
          this.$emit('click', e)
      }
  }
};
</script>

<style scoped>
.next-button {
  border-radius: 5px;
  background-color: #009be6;
  padding: 5px;
  color: #ffffff;
  width: 30vw;
  height: 40px;
  font-size: 1em;
}
.next-button:hover {
  cursor: pointer;
}

.next-button__disable {
  background-color: #bed7f0;
}

.next-button__disable:hover {
  cursor: not-allowed;
}
</style>
